import "./SoftwareSolutionsSection5.css";
import React from "react";

const SoftwareSolutionsSection5 = ({ quote, author, title, profileImage }) => {
  return (
    <section className="testimonial">
      <article className="testimonial-content">
        <div className="line-softwaresection5-top"></div>
        <blockquote className="quote">
          <em>{quote}</em>
        </blockquote>

        <footer className="author">
          <div className="author-details">
            <cite>{author}</cite>
            <p>{title}</p>
          </div>
          <img src={profileImage} alt={author} className="profile-img" />
          <div className="line-softwaresection5-bottom"></div>
        </footer>
      </article>
    </section>
  );
};

export default SoftwareSolutionsSection5;
